import { render, staticRenderFns } from "./DeadlinesCourse.vue?vue&type=template&id=2fbb6f45"
import script from "./DeadlinesCourse.vue?vue&type=script&lang=js"
export * from "./DeadlinesCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports